module.exports = __webpack_public_path__ + "static/img/no-results.0d6150c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/no-results.png
// module id = zaFZ
// module chunks = 7